import React from 'react';
import { BarChart2, LineChart, PieChart } from 'lucide-react';
import { useTypewriter } from '../hooks/useTypewriter';

const InsightsCTA: React.FC = () => {
  const words = ['insights', 'pipeline', 'MQLs', 'leads', 'customers'];
  const { text, isTyping } = useTypewriter(words, 100, 2000);

  return (
    <div className="relative bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg shadow-xl overflow-hidden my-12">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-4 left-4 text-white">
          <BarChart2 size={120} />
        </div>
        <div className="absolute bottom-4 right-4 text-white">
          <LineChart size={120} />
        </div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white">
          <PieChart size={160} />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 px-8 py-16 text-center">
        <h2 className="text-4xl font-bold text-white mb-6">
          <span className="block sm:inline">Looking for more</span>
          <span className="relative block sm:inline-block sm:ml-2 h-[40px] sm:h-auto"> {/* Fixed height container */}
            <span className="inline-block min-w-[180px]">{text}?</span>
          </span>
        </h2>
        <p className="text-blue-100 text-lg mb-8 max-w-3xl mx-auto">
          Our comprehensive services include expert paid media management across all major platforms (PPC, Meta Ads, LinkedIn Ads) and fractional CMO services to provide strategic leadership for your marketing initiatives.
        </p>
        <a
          href="https://fractionaldemand.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-6 py-3 text-lg font-medium text-blue-600 bg-white rounded-lg hover:bg-blue-50 transition-colors duration-200"
        >
          Learn More
        </a>
      </div>
    </div>
  );
};

export default InsightsCTA;